<!---->
<template>
  <el-form-item :label="label" v-bind="$attrs" class="rt-form-item-wrapper">
    <span v-if="!label" slot="label"></span> <slot />
  </el-form-item>
</template>

<script>
export default {
  name: 'RtFormItem',
  props: {
    label: String
  }
};
</script>



// WEBPACK FOOTER //
// rtFormItem.vue?7121a9b2